import { AttendanceType, DayOfWeek } from "@/api";

export const AttendanceEntryMaxLength = {
  note: 250,
};

export enum PlanningMode {
  Weekly = "weekly",
  WeeklySeries = "weeklySeries",
  MultiDay = "multiDay",
}

export interface AttendanceEntryFormValues {
  key: string;
  purposeKey: string | undefined;
  attendanceType: AttendanceType | null;
  startTime: Date | null;
  endTime: Date | null;
  note: string;
  substituteCounselorId: string | null;
}

export interface WeeklyPlanningDayFormValues {
  date: Date;
  entries: AttendanceEntryFormValues[];
}

export interface WeeklySeriesDayFormValues {
  weekday: DayOfWeek;
  entries: AttendanceEntryFormValues[];
}

export interface AttendancePlanFormBase {
  days: Array<WeeklyPlanningDayFormValues | WeeklySeriesDayFormValues>;
}

export interface WeeklyPlanningFormValues {
  days: WeeklyPlanningDayFormValues[];
}

export interface WeeklySeriesFormValues {
  dateFrom: Date | null;
  dateTo: Date | null;
  days: WeeklySeriesDayFormValues[];
}

export interface MultiDayFormValues {
  dateFrom: Date | null;
  dateTo: Date | null;
  purposeKey: string | undefined;
  attendanceType: AttendanceType | null;
  note: string;
  substituteCounselorId: string | null;
}
